import gql from 'graphql-tag';

export const query = gql`
  query cartItems($input: CartQueryInput!) {
    cartItems(input: $input) {
      _id
      storeId
      conversationId
      agentId
      productId
      variantId
      mergedToCart
      productName
      imgUrl
      qty
      price
      variant {
        variantId
        price
        options {
          name
          value
        }
        selectedOptions {
          name
          value
        }
      }
      options {
        name
        values
        position
      }
      variants {
        id
        option1
        option2
        option3
        price
        selectedOptions {
          name
          value
        }
      }
    }
  }
`;

export const subscription = gql`
  subscription cartItems($input: ConversationIdInput!) {
    cartItems(input: $input) {
      _id
      storeId
      conversationId
      agentId
      productId
      variantId
      mergedToCart
      productName
      imgUrl
      qty
      price
      variant {
        variantId
        price
        options {
          name
          value
        }
        selectedOptions {
          name
          value
        }
      }
      options {
        name
        values
        position
      }
      variants {
        id
        option1
        option2
        option3
        price
        selectedOptions {
          name
          value
        }
      }
    }
  }
`;

export const ADD_ITEM = gql`
  mutation newCartItem($input: NewCartItemInput!) {
    newCartItem(input: $input) {
      _id
      storeId
      conversationId
      agentId
      productId
      variantId
      mergedToCart
      productName
      imgUrl
      qty
      price
      variant {
        variantId
        price
        options {
          name
          value
        }
        selectedOptions {
          name
          value
        }
      }
      options {
        name
        values
        position
      }
      variants {
        id
        option1
        option2
        option3
        price
        selectedOptions {
          name
          value
        }
      }
    }
  }
`;
export const UPDATE_QUANTITY = gql`
  mutation updateQuantity($input: NewCartItemInput!) {
    updateQuantity(input: $input) {
      _id
      storeId
      conversationId
      agentId
      productId
      variantId
      mergedToCart
      productName
      imgUrl
      qty
      price
      variant {
        variantId
        price
        options {
          name
          value
        }
        selectedOptions {
          name
          value
        }
      }
      options {
        name
        values
        position
      }
      variants {
        id
        option1
        option2
        option3
        price
        selectedOptions {
          name
          value
        }
      }
    }
  }
`;
export const REMOVE_ITEM = gql`
  mutation removeCartItem($input: CartItemRemoveInput!) {
    removeCartItem(input: $input) {
      _id
    }
  }
`;

export const REMOVE_ALL_ITEMS = gql`
  mutation removeAllItems($input: ConversationIdInput!) {
    removeAllItems(input: $input) {
      _id
      productId
    }
  }
`;
export const MERGE_ITEM_TO_CART = gql`
  mutation mergeItemToCart($input: MergeItemToCartInput!) {
    mergeItemToCart(input: $input) {
      conversationId
      productId
      variantId
    }
  }
`;
